export default "__VITE_ASSET__DiF39EK___";